/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaPayload } from './servizio-mensa-payload';


export interface ServizioCreationForm { 
    tipo_servizio: ServizioCreationFormTipoServizioEnum;
    data_inizio: string;
    data_fine?: string;
    mensa?: ServizioMensaPayload;
}
export enum ServizioCreationFormTipoServizioEnum {
    MENSA = 'MENSA'
};



